import { z } from "zod";
import { idSchema, instantSchema, moneySchema, reasonSchema } from "@amber/contracts";

export const SOURCE_BULK_ACTIONS = ["scan", "pause", "resume"] as const;
export const sourceBulkActionSchema = z.enum(SOURCE_BULK_ACTIONS);
export type SourceBulkAction = z.infer<typeof sourceBulkActionSchema>;

/** Upper bound on the sources one bulk source action names, so a request stays one bounded transaction (count). */
export const MAX_BULK_SOURCES = 500;

export const sourceBulkPreviewRequestSchema = z.strictObject({
  action: sourceBulkActionSchema,
  source_ids: z.array(idSchema("src")).min(1).max(MAX_BULK_SOURCES),
});
export type SourceBulkPreviewRequest = z.input<typeof sourceBulkPreviewRequestSchema>;

export const sourceBulkPreviewSchema = z.strictObject({
  action: sourceBulkActionSchema,
  included: z.array(
    z.strictObject({
      id: idSchema("src"),
      title: z.string(),
      revision: z.number().int().positive(),
      people: z.array(z.string()),
      paused: z.strictObject({ at: instantSchema, by: z.string() }).nullable(),
    }),
  ),
  skipped: z.array(z.strictObject({ id: idSchema("src"), title: z.string(), reason: z.string() })),
  people: z.array(z.string()),
  estimate: moneySchema,
  scans_per_day: z.number().nonnegative(),
  note: z.string(),
});
export type SourceBulkPreview = z.infer<typeof sourceBulkPreviewSchema>;

export const sourceBulkRequestSchema = z.strictObject({
  action: sourceBulkActionSchema,
  sources: z
    .array(z.strictObject({ id: idSchema("src"), base_revision: z.number().int().positive() }))
    .min(1)
    .max(MAX_BULK_SOURCES),
  reason: reasonSchema,
  catch_up: z.boolean().default(true),
});
export type SourceBulkRequest = z.input<typeof sourceBulkRequestSchema>;

export const sourceBulkResultSchema = z.strictObject({ done: z.number().int().nonnegative() });
